/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_TagsInputs */

const cs_blog_tags = /** @type {(inputs: Blog_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Štítky`)
};

const en_blog_tags = /** @type {(inputs: Blog_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Blog_TagsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_tags = /** @type {((inputs?: Blog_TagsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_TagsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_tags(inputs)
	return cs_blog_tags(inputs)
});